import { isActiveStarsFilter } from "@modules/azm/filter"

const topStarsStripeContainer = () => document.querySelector("#azm-stars-promotional-content")

export function topStarsStripeChangeVisibility(visible: boolean) {
    const domContainer = topStarsStripeContainer()

    if (!domContainer) {
        return
    }

    if (visible) {
        domContainer.removeAttribute("hidden")
    } else {
        domContainer.setAttribute("hidden", "")
    }
}

topStarsStripeChangeVisibility(!isActiveStarsFilter())
